/**
 * Path-prefix → role-home (logo / breadcrumbs).
 * Mode → role-home is the shared map used by role switch and App `/` fallback.
 */
export const MODE_HOME_ROUTES = {
  Admin: '/admin-projects',
  HR: '/hr-master-data',
  Finance: '/finance-external',
  'Senior-Manager': '/senior-manager-client-office',
  'Tech-Council': '/tech-council',
  'Project-Admin': '/project-admin',
  User: '/user-dashboard',
};

export const getHomeRouteForMode = (mode) =>
  MODE_HOME_ROUTES[mode] || '/user-dashboard';

/** Returns the mode implied by a path prefix, or null when path does not encode a role. */
export const getModeForPathPrefix = (path) => {
  switch (true) {
    case path.startsWith('/user-'):
      return 'User';
    case path.startsWith('/admin-'):
      return 'Admin';
    case path.startsWith('/hr-'):
      return 'HR';
    case path.startsWith('/finance-'):
      return 'Finance';
    case path.startsWith('/senior-manager'):
      return 'Senior-Manager';
    case path.startsWith('/tech-council'):
      return 'Tech-Council';
    case path.startsWith('/project-admin'):
      return 'Project-Admin';
    default:
      return null;
  }
};

export const Routing = (path) => {
  const mode = getModeForPathPrefix(path);
  if (mode) return getHomeRouteForMode(mode);
  if (path.startsWith('/WFH')) return getHomeRouteForMode('User');
};
// This code is used in toolbar component on logo and in breadscrumb component.
